import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { Service } from '@/api/types'

export function useServices() {
  return useQuery({
    queryKey: ['services'],
    queryFn: api.listServices,
    refetchInterval: 10_000,
  })
}

export function useService(id: number | undefined) {
  return useQuery({
    queryKey: ['services', id],
    queryFn: () => api.getService(id!),
    enabled: id !== undefined,
    refetchInterval: 5_000,
  })
}

export function useCreateService() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<Service>) => api.createService(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['services'] })
    },
  })
}

export function useUpdateService() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Service> }) =>
      api.updateService(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['services'] })
    },
  })
}

export function useDeleteService() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.deleteService(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['services'] })
    },
  })
}

export function useDeployService() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.deployService(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['services'] })
      qc.invalidateQueries({ queryKey: ['deploys'] })
    },
  })
}
